import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqItems } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const FAQ = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="faq" className="section-gap bg-obsidian relative overflow-hidden">
      <div ref={ref} className="relative max-w-2xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-900 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-8 h-px bg-amber/20" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              FAQ
            </span>
            <div className="w-8 h-px bg-amber/20" />
          </div>
          <h2 className="font-heading text-[2.5rem] md:text-[3.5rem] font-light text-ivory">
            Common <em className="italic text-amber">Questions</em>
          </h2>
        </div>

        {/* Accordion */}
        <div
          className={`transition-all duration-900 delay-200 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <Accordion type="single" collapsible className="space-y-2">
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-amber/[0.06] rounded-sm px-6 lg:px-7 data-[state=open]:border-amber/[0.12] data-[state=open]:bg-obsidian-card/30 transition-all duration-400"
              >
                <AccordionTrigger className="font-heading text-[15px] md:text-[17px] font-normal text-ivory/60 hover:text-amber/80 py-5 hover:no-underline [&[data-state=open]]:text-amber/80">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="font-body text-[14px] text-ivory/30 leading-[1.8] font-light pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
